import { EStreetType, STREET_TYPES } from '@constants';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';

interface StreetTypeSelectorProps {
  value?: EStreetType;
  onChange?: (value: EStreetType) => void;
  placeholder?: string;
  disabled?: boolean;
}

export const StreetTypeSelector: React.FC<StreetTypeSelectorProps> = ({
  value,
  onChange,
  placeholder,
  disabled = false
}) => {
  const { t } = useTranslation('DefaultTranslations');

  const options = STREET_TYPES.map(streetType => ({
    label: t(streetType),
    value: streetType
  }));

  return (
    <Select
      value={value}
      onChange={onChange}
      options={options}
      placeholder={placeholder || t('SELECT_STREET_TYPE')}
      disabled={disabled}
      showSearch
      filterOption={(input, option) =>
        String(option?.label || '')
          .toLowerCase()
          .includes(input.toLowerCase())
      }
    />
  );
};
